import { WebLayout } from "@/components/shared/layout/homepage";
import { BookingConfirmation } from "@/containers/booking-confirmation";
import type { ServiceName } from "@/types/service";
import { useParams } from "@/components/hooks/use-params";

export const BookingConfirmationPage = () => {
  const { name } = useParams<{ name: ServiceName }>();
  if (!name) {
    return <div>404</div>;
  }
  return (
    <WebLayout>
      <BookingConfirmation />
    </WebLayout>
  );
};
